import React from "react";
import styled from "styled-components";

import { PrimaryButton } from "../common/Button";
import StoreButtons from "../common/StoreButtons";

const isIphone = typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent);
const APP_STORE_URL = "https://itunes.apple.com/us/app/top-nine-for-instagram-2017/id1188477208?mt=8";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bestnine&hl=en";

const LoadingGridState = () => (
  <Item style={{ marginBottom: 0 }}>
    <ItemContainer style={{ marginLeft: 0 }}>
      <Title>Don't want to wait? Download our app! </Title>
      <Text>
        No one wants another app on their phone, but this one comes with surprises we promise you’ll love!
      </Text>
      <DownloadBullets>
        <DownloadBullet>Your Top Nine in SECONDS instead of HOURS.</DownloadBullet>
        <DownloadBullet>Video and Story templates.</DownloadBullet>
        <DownloadBullet>More Instagram tools!</DownloadBullet>
      </DownloadBullets>
    </ItemContainer>
    <StoreButtons style={{ marginBottom: "26px", marginTop: 10 }} />
    <ButtonContainer
      href={isIphone ? APP_STORE_URL : PLAY_STORE_URL}
      onClick={() => {
        if (window.gtag) {
          window.gtag("event", "onclick_loading_state_button");
        }
      }}
    >
      <GoToAppStoreButton>Go to App Store</GoToAppStoreButton>
    </ButtonContainer>
  </Item>
);

const GoToAppStoreButton = styled(PrimaryButton)`
  margin: auto;
  min-height: 46px;
  max-width: 400px;
`;

const Text = styled.p`
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 500;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;

const Item = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 30px 20px;
`;

const ItemContainer = styled.div`
  flex: 1;
  margin-left: 16px;
`;

const Title = styled.p`
  font-size: 14px !important;
  color: black;
  font-weight: bold;
  text-align: left;
  line-height: 1;
  margin-bottom: 4px !important;
`;

const DownloadBullets = styled.div`
  padding: 10px 0px 0px 20px;
`;

const DownloadBullet = styled.li`
  padding: 0;
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 600;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;

const ButtonContainer = styled.a``;

export default LoadingGridState;
